"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSolution = void 0;
const indent_1 = require("../../utils/indent");
const ctx_1 = require("../ctx");
const Values = __importStar(require("../value"));
function formatSolution(mod, ctx, solution, names) {
    const properties = [];
    for (const name of names) {
        const type = (0, ctx_1.ctxLookupType)(ctx, name);
        if (type === undefined) {
            throw new Error(`[formatSolution] can not find the type of pattern variable: ${name}`);
        }
        const value = Values.PatternVar(type, name);
        properties.push(`${name}: ${Values.formatValue(mod, ctx, type, value)}`);
        // let value = solutionLookupValue(solution, name)
        // if (value === undefined) {
        //   properties.push(`${name}: TODO(${Values.formatType(mod, ctx, type)})`)
        // } else {
        //   properties.push(`${name}: ${Values.formatValue(mod, ctx, type, value)}`)
        // }
    }
    return properties.length === 0
        ? "{}"
        : `{\n${(0, indent_1.indent)(properties.join(",\n"))}\n}`;
}
exports.formatSolution = formatSolution;
//# sourceMappingURL=formatSolution.js.map